import { palette } from './palette';
import { fonts } from './fonts';
import { sizes } from './sizes';
import { breakpoints, device } from './breakpoints';

export const theme = {
  palette,
  colors: palette,
  fonts,
  sizes,
  breakpoints,
  device,
};
